import { render } from "./TransferErrorBanner.vue?vue&type=template&id=452e07a6&scoped=true"
import script from "./TransferErrorBanner.vue?vue&type=script&lang=js"
export * from "./TransferErrorBanner.vue?vue&type=script&lang=js"

import "./TransferErrorBanner.vue?vue&type=style&index=0&id=452e07a6&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-452e07a6"]])

export default __exports__